"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.impactUpdate = exports.impactTypeList = exports.impactSuccess = exports.impactSoftDelete = exports.impactRestoreSoftDelete = exports.impactResetListByIdYear = exports.impactResetAction = exports.impactReset = exports.impactPanelSequence = exports.impactListSort = exports.impactListRestoreSoftDelete = exports.impactListByIdYear = exports.impactList = exports.impactError = exports.impactDeleteAll = exports.impactDelete = exports.impactCriteriaList = exports.impactCreate = exports.impactBulkSoftDelete = exports.impactBulkRestore = exports.impactBulkHardDelete = void 0;
var _impact = require("./impact.constant");
// common success
var impactSuccess = function impactSuccess(actionType, data) {
  return {
    type: _impact.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.impactSuccess = impactSuccess;
var impactError = function impactError(actionType, error) {
  return {
    type: _impact.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * search impact list with id and year
 * @param payload
 * @returns api response
 * @description this function used to search impact with id and year.
 */
exports.impactError = impactError;
var impactListByIdYear = function impactListByIdYear(data) {
  return {
    type: _impact.actionTypes.LIST_BY_ID_YEAR,
    payload: data
  };
};

/**
 * type list
 * @param payload
 * @returns api response
 * @description this function used to get type list.
 */
exports.impactListByIdYear = impactListByIdYear;
var impactTypeList = function impactTypeList(data) {
  return {
    type: _impact.actionTypes.TYPE_LIST,
    payload: data
  };
};

/**
 * impact list with params
 * @param payload
 * @returns api response
 * @description this function used to impact list with params.
 */
exports.impactTypeList = impactTypeList;
var impactList = function impactList(data) {
  return {
    type: _impact.actionTypes.LIST,
    payload: data
  };
};

/**
 * impact list with params
 * @param payload
 * @returns api response
 * @description this function used to impact list with params.
 */
exports.impactList = impactList;
var impactListSort = function impactListSort(data) {
  return {
    type: _impact.actionTypes.LISTSORT,
    payload: data
  };
};

/**
 * impact criteriaList
 * @param payload
 * @returns api response
 * @description this function used to get criteria list.
 */
exports.impactListSort = impactListSort;
var impactCriteriaList = function impactCriteriaList() {
  return {
    type: _impact.actionTypes.CRITERIA_LIST
  };
};

/**
 * impact create
 * @param payload
 * @returns api response
 * @description this function used to impact create given inputs.
 */
exports.impactCriteriaList = impactCriteriaList;
var impactCreate = function impactCreate(data) {
  return {
    type: _impact.actionTypes.CREATE,
    payload: data
  };
};

/**
 * impact update
 * @param payload
 * @returns api response
 * @description this function used to update impact given inputs.
 */
exports.impactCreate = impactCreate;
var impactUpdate = function impactUpdate(data) {
  return {
    type: _impact.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * impact delete
 * @param payload
 * @returns api response
 * @description this function used to delete impact of given params.
 */
exports.impactUpdate = impactUpdate;
var impactDelete = function impactDelete(data) {
  return {
    type: _impact.actionTypes.DELETE,
    payload: data
  };
};

/**
 * impact delete
 * @param payload
 * @returns api response
 * @description this function used to delete impact of given params.
 */
exports.impactDelete = impactDelete;
var impactDeleteAll = function impactDeleteAll(data) {
  return {
    type: _impact.actionTypes.DELETE_ALL,
    payload: data
  };
};

/**
 * impact update sequence
 * @param payload
 * @returns api response
 * @description this function used to update impact sequence.
 */
exports.impactDeleteAll = impactDeleteAll;
var impactPanelSequence = function impactPanelSequence(data) {
  return {
    type: _impact.actionTypes.SEQUENCE,
    payload: data
  };
};
exports.impactPanelSequence = impactPanelSequence;
var impactSoftDelete = function impactSoftDelete(data) {
  return {
    type: _impact.actionTypes.SOFT_DELETE,
    payload: data
  };
};
exports.impactSoftDelete = impactSoftDelete;
var impactRestoreSoftDelete = function impactRestoreSoftDelete(data) {
  return {
    type: _impact.actionTypes.RESTORE_SOFT_DELETE,
    payload: data
  };
};
exports.impactRestoreSoftDelete = impactRestoreSoftDelete;
var impactListRestoreSoftDelete = function impactListRestoreSoftDelete(data) {
  return {
    type: _impact.actionTypes.LIST_RESTORE_SOFT_DELETE,
    payload: data
  };
};
exports.impactListRestoreSoftDelete = impactListRestoreSoftDelete;
var impactBulkSoftDelete = function impactBulkSoftDelete(data) {
  return {
    type: _impact.actionTypes.BULK_SOFT_DELETE,
    payload: data
  };
};
exports.impactBulkSoftDelete = impactBulkSoftDelete;
var impactBulkHardDelete = function impactBulkHardDelete(data) {
  return {
    type: _impact.actionTypes.BULK_DELETE,
    payload: data
  };
};
exports.impactBulkHardDelete = impactBulkHardDelete;
var impactBulkRestore = function impactBulkRestore(data) {
  return {
    type: _impact.actionTypes.BULK_RESTORE,
    payload: data
  };
};

/**
 * impact delete
 * @param payload
 * @returns api response
 * @description this function used to delete impact of given params.
 */
exports.impactBulkRestore = impactBulkRestore;
var impactReset = function impactReset(data) {
  return {
    type: _impact.actionTypes.RESET,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to delete impact of given params.
 */
exports.impactReset = impactReset;
var impactResetAction = function impactResetAction() {
  return {
    type: _impact.actionTypes.RESET_ACTION
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to delete impact of given params.
 */
exports.impactResetAction = impactResetAction;
var impactResetListByIdYear = function impactResetListByIdYear() {
  return {
    type: _impact.actionTypes.RESET_LISTBYIDYEAR
  };
};
exports.impactResetListByIdYear = impactResetListByIdYear;